import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CiacService } from 'src/app/services/http/ciac.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalMsgService } from 'src/app/services/modal-msg.service';

@Component({
  selector: 'app-dce',
  templateUrl: './dce.component.html',
  styleUrls: ['./dce.component.scss']
})
export class DceComponent implements OnInit {

  sorting: { 
    id: "asc",
    nome: ""
  }
  filter = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  form = new FormGroup({
    dcs: new FormControl('', [Validators.required]),
    tipoConsulta: new FormControl('', [Validators.required]),
    conversao: new FormControl('', [Validators.required]),
    nome: new FormControl(''),
    formatEntrada: new FormControl(''),
    formatSaida: new FormControl(''),
    regex: new FormControl(''),
    caminho: new FormControl(''),
    valorPadrao: new FormControl(''),
    descricao: new FormControl(''),
    dadosConsultaEntradaPai: new FormControl('')
  });

  id;
  consultaParametros = [];
  consulta: any;
  fornecedor: any;
  listaDadoSaida = [];
  listaTipoConsulta = [];
  listaConversao = [];
  dadosAtualizacao = [];
  listaDadosConsultaPai = [];

  constructor(private activatedRoute: ActivatedRoute, private ciacService: CiacService, private router: Router, private modal: ModalMsgService) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id || null;
    this.inicialize();

    this.ciacService.dadosFormDCE.subscribe(c => {
      if(c) {
        if(c.id) {
          this.dadosAtualizacao.push({ id: c.id });
        }
        this.form.controls.dcs.patchValue(c.idDadoConsultaSaida);
        this.form.controls.tipoConsulta.patchValue(c.idTipoConsulta);
        this.form.controls.conversao.patchValue(c.idConversao);
        this.form.controls.nome.patchValue(c.nome);
        this.form.controls.formatEntrada.patchValue(c.formatoEntrada);
        this.form.controls.formatSaida.patchValue(c.formatoSaida);
        this.form.controls.regex.patchValue(c.regex);
        this.form.controls.caminho.patchValue(c.caminho);
        this.form.controls.valorPadrao.patchValue(c.valorPadrao);
        this.form.controls.descricao.patchValue(c.descricao);
        this.form.controls.dadosConsultaEntradaPai.patchValue(c.idDadosConsultaEntradaPai);
      }
    });

  }

  inicialize() {
    this.ciacService.getConsultaFornecedor(this.id).then(c => { 
      this.consultaParametros = this.consultaParametros.concat(c)
      this.consulta = this.consultaParametros[0].consulta;
      this.fornecedor = this.consultaParametros[0].fornecedor;

      let filtro = { ...this.filter, idConsulta: this.consultaParametros[0].idConsulta }
      this.ciacService.listDadosConsultaSaida(this.id).then(c => this.listaDadoSaida = this.listaDadoSaida.concat(c.lista));
      this.ciacService.getTipoConsultaCredito().then(c => this.listaTipoConsulta = this.listaTipoConsulta.concat(c));
      this.ciacService.getListaConversao(filtro).then(c => this.listaConversao = this.listaConversao.concat(c.lista));
      this.ciacService.getListaTipoDadosEntrada(this.id).then(c => { this.listaDadosConsultaPai = this.listaDadosConsultaPai.concat(c.lista) });
    });
  }

  criaJSON() {
    let json;

    if(this.dadosAtualizacao.length > 0) {
      json = {
        id: this.dadosAtualizacao[0].id,
        idConsultaFornecedor: this.id ? parseInt(this.id) : null,
        idDadoConsultaSaida: this.form.controls.dcs.value ? parseInt(this.form.controls.dcs.value) : null,
        idTipoCampoConsulta: this.form.controls.tipoConsulta.value ? parseInt(this.form.controls.tipoConsulta.value) : null,
        idConversao: this.form.controls.conversao.value ? parseInt(this.form.controls.conversao.value) : null,
        nome: this.form.controls.nome.value,
        formatoEntrada: this.form.controls.formatEntrada.value,
        formatoSaida: this.form.controls.formatSaida.value,
        regex: this.form.controls.regex.value,
        caminho: this.form.controls.caminho.value,
        valorPadrao: this.form.controls.valorPadrao.value,
        descricao: this.form.controls.descricao.value,
        idDadosConsultaEntradaPai: parseInt(this.form.controls.dadosConsultaEntradaPai.value)
      }
    }else {
      json = {
        idConsultaFornecedor: this.id ? parseInt(this.id) : null,
        idDadoConsultaSaida: this.form.controls.dcs.value ? parseInt(this.form.controls.dcs.value) : null,
        idTipoCampoConsulta: this.form.controls.tipoConsulta.value ? parseInt(this.form.controls.tipoConsulta.value) : null,
        idConversao: this.form.controls.conversao.value ? parseInt(this.form.controls.conversao.value) : null,
        nome: this.form.controls.nome.value,
        formatoEntrada: this.form.controls.formatEntrada.value,
        formatoSaida: this.form.controls.formatSaida.value,
        regex: this.form.controls.regex.value,
        caminho: this.form.controls.caminho.value,
        valorPadrao: this.form.controls.valorPadrao.value,
        descricao: this.form.controls.descricao.value,
        idDadosConsultaEntradaPai: parseInt(this.form.controls.dadosConsultaEntradaPai.value)
      }
    }

    return json;
  }

  submitForm() {
    let dados = this.criaJSON();
    this.ciacService.addDadosEntrada(dados).then(c => {
      if(c.success) {
        this.router.navigateByUrl('/listar', {skipLocationChange: true}).then( () =>
          this.router.navigate(['ciac', 'consultas-fornecedores', 'dados-consulta-entrada', this.id ])
        );
      }else {
        this.modal.openDialog(
          'Dados de entrada já cadastrado',
          'Por favor, verifique os campos.',
          'danger'
        );
        return;
      }
    });
  }

}
